import React, { FunctionComponent, useEffect } from 'react'
import classnames from 'classnames'

interface Meta {
  error: string
  submitFailed: boolean
}

export interface Props {
  label: string
  input: any
  meta: Meta
  gridClass?: string
  options: { value: string; label: string }[]
  isLoading?: boolean
}

const MultiSelectCheckboxField: FunctionComponent<Props> = ({
  label,
  input,
  meta,
  gridClass,
  options,
  isLoading = false,
}) => {
  const { submitFailed, error } = meta

  // Normalize the value to always be an array of strings
  const normalizeValue = (value: any): string[] => {
    if (!value || value === '') return []
    if (Array.isArray(value)) return value.map(String)
    return [String(value)]
  }

  const selectedValues = normalizeValue(input.value)

  const handleCheckboxChange = (optionValue: string) => {
    const newValues = selectedValues.includes(optionValue)
      ? selectedValues.filter((v: string) => v !== optionValue)
      : [...selectedValues, optionValue]

    input.onChange(newValues.length > 0 ? newValues : [])
  }

  useEffect(() => {
    if (!selectedValues.length) {
      input.onChange(options.map((option) => option.value))
    }
  }, [isLoading])

  return (
    <div
      className={classnames('form__group', {
        [`${gridClass}`]: gridClass,
      })}
    >
      {label && <label className="form__label">{label}</label>}
      <div
        style={{
          border: '1px solid #e5e8eb',
          padding: '8px',
          maxHeight: '100px',
          overflowY: 'auto',
        }}
      >
        {isLoading ? (
          <div style={{ padding: '8px' }}>Loading...</div>
        ) : (
          options.map((option) => (
            <label
              key={option.value}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '5px 4px',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={selectedValues.includes(option.value)}
                onChange={() => handleCheckboxChange(option.value)}
                style={{
                  marginRight: '8px',
                  cursor: 'pointer',
                }}
              />
              <span>{option.label}</span>
            </label>
          ))
        )}
      </div>
      {submitFailed && error && (
        <p className="form__help-text text-error">{error}</p>
      )}
    </div>
  )
}

export default MultiSelectCheckboxField
